import React, { CSSProperties, FC } from 'react';
import './Button.scss';

type BottonProps = {
    fontSize?: string;
    height?: string;
    width?: string;
    icon?: string;
    iconSize?: string;
    title?: string;
    disabled?: boolean;
    style?: CSSProperties;
    onClick?: () => void;
};

const Button: FC<BottonProps> = ({
    width = '100%',
    fontSize = '14px',
    height = '40px',
    title,
    disabled = false,
    icon,
    iconSize = '16px',
    style = {},
    onClick,
}) => {
    return (
        <button
            onClick={onClick}
            className={`Button ${disabled ? 'disabled' : ''}`}
            style={{ fontSize, height, width, ...style }}>
            {icon && (
                <img
                    src={icon}
                    style={{ width: iconSize, height: iconSize }}
                />
            )}
            {title && title}
        </button>
    );
};

export default Button;
